import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import yaml from "js-yaml";
// import { useCookies } from 'react-cookie'

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        // fallbackLng: "en",
        fallbackLng: "eo",
        debug: false,
        detection: {
            // order: ["queryString", "htmlTag", "cookie", "path", "subdomain"],
            // order: ["queryString", "cookie"],
            order: ["cookie", "queryString"],
            caches: ["cookie"],
        },
        // backend: {
        //     loadPath: "/locales/{{lng}}/translation.json",
        // },
        backend: {
            loadPath: "/esperantoTTS/locales/{{lng}}/translation.yaml",
            // loadPath: "/locales/{{lng}}/translation.yaml",
            parse: function (data) {
                return yaml.load(data);
            },
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
